const log = {
  error: console.error,
  warn: console.warn,
  info: console.log,
  trace: console.trace,
  debug: console.debug,
  time: console.time,
  timeEnd: console.timeEnd,
};

export default log;
